// MILES Business Hub — i18n FR / EN / DE (module dédié, ne touche pas au site public)
import { useLang } from "@/lib/i18n";

const fr = {
  "comm.rate_applied": "Taux appliqué", "comm.no_payouts": "Aucun versement pour l'instant.", "comm.bank_restricted": "Réservé au rôle Owner / Admin — contactez votre administrateur.",
  "mb.mode.flight": "Vol", "mb.mode.train": "Train", "team.saved": "Membre enregistré", "common.invalid": "Certains champs sont incomplets — vérifiez le formulaire.",
  "nav.overview": "Vue d'ensemble", "nav.new_mission": "Nouvelle mission", "nav.missions": "Missions",
  "nav.guests": "Guests",
  "nav.places": "Places", "nav.billing": "Facturation", "nav.commissions": "Commissions",
  "nav.reports": "Rapports", "nav.team": "Équipe", "nav.settings": "Réglages",
  "hub.new": "+ Mission", "hub.search_placeholder": "Rechercher un guest, une mission, un vol, une facture…",
  "hub.hello": "Bonjour {name}", "hub.logout": "Déconnexion", "hub.back_site": "← Retour au site",

  "overview.welcome": "Voici votre journée.", "overview.today": "Aujourd'hui",
  "overview.arrivals": "Arrivées", "overview.departures": "Départs", "overview.active": "Missions actives",
  "overview.completed": "Terminées", "overview.action_required": "Nécessite une action",
  "overview.none": "Rien à signaler — MILES surveille tout pour vous.",
  "overview.timeline": "Timeline opérationnelle", "overview.upcoming": "À venir",
  "overview.quick": "Réservation rapide", "overview.quick_hint": "Pour les besoins simples — le Mission Builder prend le relais si nécessaire.",
  "overview.pickup": "Départ", "overview.destination": "Destination", "overview.when": "Quand ?",
  "overview.guest": "Voyageur", "overview.continue": "Continuer",
  "overview.spend_month": "Dépenses du mois", "overview.missions_month": "Missions ce mois",
  "overview.no_missions": "Aucune mission aujourd'hui — la journée est calme.",

  "hub.title": "Que devons-nous organiser ?", "hub.subtitle": "Décrivez le besoin — MILES organise le reste.",
  "type.transfer": "Transport privé", "type.transfer_d": "Un trajet privé, avec autant d'étapes que nécessaire.",
  "type.airport": "Transfert Aéroport", "type.airport_d": "Prise en charge liée à un vol ou un train.",
  "type.private_aviation": "Aviation privée", "type.private_aviation_d": "Tail number, FBO, handler — sans faux numéro de vol.",
  "type.hourly": "Chauffeur à disposition", "type.hourly_d": "Quelques heures, une demi-journée, une journée ou plus.",
  "type.multi_stop": "Plusieurs arrêts", "type.multi_stop_d": "Un itinéraire avec plusieurs destinations.",
  "type.group": "Groupe", "type.group_d": "Plusieurs voyageurs, éventuellement plusieurs véhicules.",
  "type.event": "Événement", "type.event_d": "Conférence, mariage, délégation, séminaire…",
  "type.shuttle": "Navette", "type.shuttle_d": "Rotations entre plusieurs lieux.",
  "type.luggage": "Bagages", "type.luggage_d": "Transport de bagages avec ou sans passager.",
  "type.delivery": "Livraison", "type.delivery_d": "Document, objet ou effets personnels.",
  "type.recurring": "Mission récurrente", "type.recurring_d": "Un trajet répété, ex. chaque lundi 07:30.",
  "type.custom": "Demande particulière", "type.custom_d": "Pour tout besoin non couvert — MILES s'en occupe.",

  "mb.who": "Qui ou quoi transportons-nous ?", "mb.where": "Où ?", "mb.when": "Quand ?",
  "mb.how": "Comment ?", "mb.instructions": "Instructions", "mb.payment": "Qui paie ?",
  "mb.review": "Résumé de la mission",
  "mb.guests": "Voyageurs", "mb.add_guest": "Ajouter un voyageur", "mb.new_guest": "Nouveau guest",
  "mb.search_guest": "Chercher dans l'annuaire…", "mb.save_guest": "Enregistrer comme Guest",
  "mb.passengers": "Passagers", "mb.luggage": "Bagages",
  "mb.pickup": "Départ", "mb.dropoff": "Destination", "mb.add_stop": "Ajouter une étape",
  "mb.stop": "Étape", "mb.date": "Date", "mb.time": "Heure", "mb.now": "Dès que possible",
  "mb.flight_number": "Numéro de vol", "mb.terminal": "Terminal", "mb.train_number": "Train (facultatif)",
  "mb.station": "Gare", "mb.platform": "Quai",
  "mb.tail_number": "Tail number", "mb.fbo": "FBO", "mb.handler": "Handler", "mb.eta": "ETA",
  "mb.aviation_contact": "Contact aviation",
  "mb.duration": "Durée", "mb.hours": "heures", "mb.schedule": "Programme prévisionnel",
  "mb.schedule_hint": "Ou simplement : itinéraire à définir avec le chauffeur.",
  "mb.flexible_dest": "Destination flexible",
  "mb.vehicle": "Véhicule", "mb.vehicles": "Véhicules",
  "mb.vehicle.standard": "Standard", "mb.vehicle.business": "Business", "mb.vehicle.first": "First", "mb.vehicle.van": "Van",
  "mb.vehicle.luggage_van": "Van bagages", "mb.count": "Nombre",
  "mb.driver_note": "Consigne chauffeur",
  "mb.driver_language": "Langue du chauffeur", "mb.internal_note": "Note interne",
  "mb.payer.partner": "Le partenaire",
  "mb.payer.guest": "Le voyageur",
  "mb.how_pay": "Comment ?",
  "mb.method.business_invoice": "Facture Business",
  "mb.method.business_invoice_h": "La course rejoint la facturation du compte Business selon ses conditions.",
  "mb.method.card": "Carte bancaire",
  "mb.method.card_h": "Paiement immédiat par carte — formulaire sécurisé SumUp directement dans cette page.",
  "mb.method.card_guest": "Carte à bord",
  "mb.method.card_guest_h": "Le voyageur règle par carte via le terminal SumUp auprès du chauffeur — aucun paiement en ligne.",
  "mb.method.payment_link": "Lien de paiement",
  "mb.method.payment_link_h": "Un lien de paiement SumUp du montant exact est envoyé au voyageur et peut être copié ici.",
  "mb.method.cash": "Espèces",
  "mb.method.cash_h": "Le voyageur paiera en espèces ; MILES enregistre l'encaissement.",
  "pay.pending": "Paiement en attente", "pay.paid": "Payée", "pay.copy": "Copier le lien de paiement",
  "pay.copied": "Lien copié", "pay.cash_planned": "Paiement en espèces prévu",
  "pay.widget_title": "Règlement de la mission",
  "pay.now_amount": "Payer {amount}",
  "pay.processing": "Paiement en cours…",
  "pay.paid_ok": "Paiement confirmé — la mission est réglée.",
  "pay.failed": "Le paiement a été refusé. Vérifiez la carte ou réessayez.", "pay.retry": "Réessayer le paiement",
  "pay.pending_check": "Paiement en cours de vérification — le statut sera confirmé dans un instant.",
  "pay.widget_unavailable": "Le formulaire de paiement n'a pas pu être créé — régénérez-le depuis la mission.",
  "pay.on_invoice": "Sur la facture Business", "pay.now": "Payer en ligne",
  "pay.link_sent": "Le lien a été envoyé au voyageur dans son e-mail de confirmation. Il se met à jour tout seul après paiement.",
  "pay.success": "Paiement reçu — la mission est marquée comme payée.",
  "pay.cancelled": "Paiement interrompu — la mission reste en attente de paiement.",
  "mb.bag_count": "Nombre de bagages", "mb.bag_types": "Types (valises, skis…)",
  "mb.oversized": "Bagages hors format", "mb.collect_from": "Personne remettant les bagages",
  "mb.deliver_to": "Destinataire", "mb.deliver_before": "À livrer avant",
  "mb.item_description": "Description de l'objet", "mb.fragile": "Fragile",
  "mb.sender": "Expéditeur", "mb.recipient": "Destinataire",
  "mb.recurrence": "Récurrence", "mb.every": "Chaque", "mb.from": "Du", "mb.to": "Au",
  "mb.weekday.0": "lundi", "mb.weekday.1": "mardi", "mb.weekday.2": "mercredi",
  "mb.weekday.3": "jeudi", "mb.weekday.4": "vendredi", "mb.weekday.5": "samedi", "mb.weekday.6": "dimanche",
  "mb.shuttle_frequency": "Fréquence (minutes)", "mb.shuttle_window": "Horaires",
  "mb.custom_desc": "Décrivez ce dont vous avez besoin",
  "mb.custom_hint": "Photo, document ou instructions : envoyez-les à info@gomiles.ch en citant votre numéro de mission.",
  "mb.confirm": "Confirmer cette mission", "mb.creating": "Nous organisons votre course…",
  "mb.price_est": "Prix estimé", "mb.to_quote": "Prix confirmé par MILES sous peu",
  "mb.commission_est": "Commission estimée",
  "mb.confirmed_title": "Tout est prêt.", "mb.confirmed_sub": "Mission confirmée — le voyageur est notifié.",
  "mb.track": "Suivre la mission", "mb.add_return": "Réserver le retour", "mb.new_one": "Nouvelle mission",
  "mb.back": "Retour", "mb.next": "Continuer",
  "mb.select_type_first": "Choisissez d'abord le type de mission",
  "mb.flight_tracked": "MILES suit le vol. Aucune action nécessaire.",
  "mb.templates": "Modèles enregistrés", "mb.save_template": "Enregistrer comme modèle",
  "mb.template_name": "Nom du modèle",

  "missions.title": "Missions", "missions.all": "Toutes", "missions.empty": "Aucune mission pour l'instant.",
  "missions.empty_hint": "Créez votre première mission — MILES s'occupe du reste.",
  "missions.date": "Date", "missions.guest": "Voyageur", "missions.route": "Trajet",
  "missions.status": "Statut", "missions.amount": "Montant",
  "status.confirmed": "Confirmée", "status.in_progress": "En cours", "status.completed": "Terminée",
  "status.cancelled": "Annulée", "status.to_quote": "À chiffrer",
  "detail.timeline": "Historique", "detail.duplicate": "Dupliquer", "detail.return": "Réserver le retour",
  "detail.cancel": "Annuler la mission", "detail.complete": "Marquer terminée",
  "detail.bookings": "Véhicules & suivi", "detail.custody": "Chaîne de possession",
  "detail.collected": "Récupérés", "detail.delivered": "Livrés", "detail.received_by": "Réceptionné par",
  "detail.photo": "Photo (URL)", "detail.update_custody": "Mettre à jour",
  "detail.notes": "Notes", "detail.refs": "Références", "detail.guests": "Voyageurs",
  "detail.pricing": "Tarification", "detail.to_quote": "Prix en cours de chiffrage par MILES",
  "detail.tracking_link": "Lien de suivi",

  "guests.title": "Guests", "guests.subtitle": "Vos voyageurs fréquents — préférences, historique, confidentialité.",
  "guests.new": "Nouveau guest", "guests.empty": "Aucun guest enregistré.",
  "guests.first_name": "Prénom", "guests.last_name": "Nom", "guests.phone": "Téléphone",
  "guests.email": "E-mail", "guests.language": "Langue", "guests.company": "Entreprise",
  "guests.title_field": "Titre / fonction", "guests.notes": "Notes", "guests.preferences": "Préférences",
  "guests.pref_hint": "Ex. communication en anglais · préfère un Van · ne pas appeler avant arrivée",
  "guests.trips": "missions", "guests.recent": "Dernières missions",
  "guests.book": "Réserver pour ce guest", "guests.edit": "Modifier",
  "guests.anonymize": "Anonymiser", "guests.anonymize_confirm": "Anonymiser ce profil ? Les données personnelles seront effacées, l'historique financier est conservé.",
  "guests.delete": "Supprimer", "guests.save": "Enregistrer", "guests.cancel": "Annuler",


  "places.title": "Places", "places.subtitle": "Vos adresses fréquentes — hôtel, aéroports, gares, restaurants, FBO…",
  "places.new": "Nouvelle adresse", "places.name": "Nom", "places.address": "Adresse",
  "places.category": "Catégorie", "places.empty": "Aucune adresse enregistrée.",
  "places.cat.hotel": "Hôtel", "places.cat.airport": "Aéroport", "places.cat.station": "Gare",
  "places.cat.restaurant": "Restaurant", "places.cat.company": "Entreprise", "places.cat.clinic": "Clinique",
  "places.cat.fbo": "FBO", "places.cat.residence": "Résidence", "places.cat.venue": "Salle / venue",
  "places.cat.other": "Autre",

  "billing.title": "Facturation", "billing.balance": "Solde", "billing.open": "Factures ouvertes",
  "billing.paid": "Factures payées", "billing.spend_month": "Dépenses du mois",
  "billing.unbilled": "Missions non facturées", "billing.next": "Prochaine facture",
  "billing.cycle": "Cycle de facturation", "billing.cycle.monthly": "Mensuelle",
  "billing.cycle.weekly": "Hebdomadaire", "billing.cycle.biweekly": "Bimensuelle",
  "billing.cycle.per_mission": "Par mission",

  "comm.title": "Commissions", "comm.available": "Disponible", "comm.pending": "En attente",
  "comm.paid_year": "Versé cette année", "comm.lifetime": "Total cumulé",
  "comm.rate": "Taux actuel", "comm.date": "Date", "comm.booking": "Mission",
  "comm.guest": "Guest", "comm.service": "Service", "comm.commissionable": "Montant commissionnable",
  "comm.commission": "Commission", "comm.status": "Statut", "comm.payout": "Versement",
  "comm.export": "Exporter CSV", "comm.empty": "Aucune commission pour l'instant.",
  "comm.disabled": "Les commissions ne sont pas activées sur votre compte — contactez MILES.",
  "comm.st.pending": "En attente", "comm.st.confirmed": "Confirmée", "comm.st.available": "Disponible",
  "comm.st.paid": "Versée", "comm.st.cancelled": "Annulée", "comm.st.adjusted": "Ajustée",
  "comm.payouts": "Versements", "comm.payout_details": "Coordonnées bancaires",
  "comm.hold_warning": "Coordonnées récemment modifiées — le prochain versement sera vérifié par MILES avant exécution.",

  "pay.holder": "Titulaire du compte", "pay.legal_name": "Raison sociale", "pay.address": "Adresse",
  "pay.country": "Pays", "pay.iban": "IBAN", "pay.bic": "BIC / SWIFT", "pay.currency": "Devise",
  "pay.accounting_email": "E-mail comptabilité", "pay.uid": "UID", "pay.vat": "N° TVA",
  "pay.save": "Enregistrer", "pay.saved": "Coordonnées enregistrées — vérification MILES avant prochain versement.",
  "pay.iban_invalid": "L'IBAN saisi n'est pas valide.",

  "reports.title": "Rapports", "reports.missions": "Missions", "reports.completed": "Terminées",
  "reports.cancelled": "Annulées", "reports.spend": "Dépenses", "reports.avg": "Panier moyen",
  "reports.airport": "Transferts aéroport", "reports.hours": "Heures réservées",
  "reports.guests": "Voyageurs transportés", "reports.luggage": "Missions bagages",
  "reports.commission": "Commissions gagnées", "reports.by_type": "Par type de mission",


  "team.role.owner": "Owner", "team.role.admin": "Admin", "team.role.concierge": "Concierge",
  "team.role.front_desk": "Front Desk", "team.role.event_manager": "Event Manager",
  "team.role.finance": "Finance", "team.role.viewer": "Viewer", "team.role.booker": "Concierge",

  "settings.profile": "Profil partenaire", "settings.business_type": "Type d'organisation",
  "settings.bt.company": "Entreprise", "settings.bt.hotel": "Hôtel", "settings.bt.hotel_group": "Groupe hôtelier",
  "settings.bt.concierge": "Conciergerie", "settings.bt.travel_agency": "Agence de voyage",
  "settings.bt.event_agency": "Agence événementielle", "settings.bt.clinic": "Clinique",
  "settings.bt.family_office": "Family office", "settings.bt.other": "Autre",
  "settings.locations": "Établissements", "settings.location_new": "Ajouter un établissement",
  "settings.payout": "Versements & coordonnées bancaires",
  "settings.activity": "Journal d'activité",

  "palette.title": "Recherche & actions rapides", "palette.new_mission": "Nouvelle mission",
  "palette.open_today": "Ouvrir aujourd'hui", "palette.find_invoice": "Chercher une facture",
  "palette.guests": "Guests", "palette.missions": "Missions", "palette.invoices": "Factures",
  "palette.empty": "Aucun résultat.",
  "common.close": "Fermer", "common.loading": "Chargement…", "common.save": "Enregistrer",
  "common.delete": "Supprimer", "common.edit": "Modifier", "common.view": "Voir",
  "common.error": "Une erreur est survenue.",
};

const en = {
  "comm.rate_applied": "Rate applied", "comm.no_payouts": "No payouts yet.", "comm.bank_restricted": "Restricted to Owner / Admin — contact your administrator.",
  "mb.mode.flight": "Flight", "mb.mode.train": "Train", "team.saved": "Member saved", "common.invalid": "Some fields are incomplete — please check the form.",
  "nav.overview": "Overview", "nav.new_mission": "New mission", "nav.missions": "Missions",
  "nav.guests": "Guests",
  "nav.places": "Places", "nav.billing": "Billing", "nav.commissions": "Commissions",
  "nav.reports": "Reports", "nav.team": "Team", "nav.settings": "Settings",
  "hub.new": "+ Mission", "hub.search_placeholder": "Search a guest, mission, flight, invoice…",
  "hub.hello": "Hello {name}", "hub.logout": "Log out", "hub.back_site": "← Back to site",

  "overview.welcome": "Here is your day.", "overview.today": "Today",
  "overview.arrivals": "Arrivals", "overview.departures": "Departures", "overview.active": "Active missions",
  "overview.completed": "Completed", "overview.action_required": "Action required",
  "overview.none": "All clear — MILES is watching everything for you.",
  "overview.timeline": "Operational timeline", "overview.upcoming": "Upcoming",
  "overview.quick": "Quick booking", "overview.quick_hint": "For simple needs — the Mission Builder takes over if needed.",
  "overview.pickup": "Pickup", "overview.destination": "Destination", "overview.when": "When?",
  "overview.guest": "Guest", "overview.continue": "Continue",
  "overview.spend_month": "Spend this month", "overview.missions_month": "Missions this month",
  "overview.no_missions": "No missions today — a calm day.",

  "hub.title": "What should we organize?", "hub.subtitle": "Describe the need — MILES handles the rest.",
  "type.transfer": "Private transfer", "type.transfer_d": "A private ride, with as many stops as needed.",
  "type.airport": "Airport Transfer", "type.airport_d": "Pickup linked to a flight or train.",
  "type.private_aviation": "Private aviation", "type.private_aviation_d": "Tail number, FBO, handler — no fake commercial flight.",
  "type.hourly": "Chauffeur at disposal", "type.hourly_d": "A few hours, half a day, a full day or more.",
  "type.multi_stop": "Multiple stops", "type.multi_stop_d": "An itinerary with several destinations.",
  "type.group": "Group", "type.group_d": "Several passengers, possibly several vehicles.",
  "type.event": "Event", "type.event_d": "Conference, wedding, delegation, seminar…",
  "type.shuttle": "Shuttle", "type.shuttle_d": "Rotations between several locations.",
  "type.luggage": "Luggage", "type.luggage_d": "Luggage transport with or without passenger.",
  "type.delivery": "Delivery", "type.delivery_d": "Document, item or personal effects.",
  "type.recurring": "Recurring mission", "type.recurring_d": "A repeated ride, e.g. every Monday 07:30.",
  "type.custom": "Special request", "type.custom_d": "For anything not covered — MILES takes care of it.",

  "mb.who": "Who or what are we moving?", "mb.where": "Where?", "mb.when": "When?",
  "mb.how": "How?", "mb.instructions": "Instructions", "mb.payment": "Who pays?",
  "mb.review": "Mission summary",
  "mb.guests": "Guests", "mb.add_guest": "Add a guest", "mb.new_guest": "New guest",
  "mb.search_guest": "Search the directory…", "mb.save_guest": "Save as Guest",
  "mb.passengers": "Passengers", "mb.luggage": "Luggage",
  "mb.pickup": "Pickup", "mb.dropoff": "Destination", "mb.add_stop": "Add a stop",
  "mb.stop": "Stop", "mb.date": "Date", "mb.time": "Time", "mb.now": "As soon as possible",
  "mb.flight_number": "Flight number", "mb.terminal": "Terminal", "mb.train_number": "Train (optional)",
  "mb.station": "Station", "mb.platform": "Platform",
  "mb.tail_number": "Tail number", "mb.fbo": "FBO", "mb.handler": "Handler", "mb.eta": "ETA",
  "mb.aviation_contact": "Aviation contact",
  "mb.duration": "Duration", "mb.hours": "hours", "mb.schedule": "Planned schedule",
  "mb.schedule_hint": "Or simply: itinerary to be defined with the chauffeur.",
  "mb.flexible_dest": "Flexible destination",
  "mb.vehicle": "Vehicle", "mb.vehicles": "Vehicles",
  "mb.vehicle.standard": "Standard", "mb.vehicle.business": "Business", "mb.vehicle.first": "First", "mb.vehicle.van": "Van",
  "mb.vehicle.luggage_van": "Luggage van", "mb.count": "Count",
  "mb.driver_language": "Chauffeur language", "mb.internal_note": "Internal note",
  "mb.driver_note": "Chauffeur instruction",
  "mb.payer.partner": "The partner",
  "mb.payer.guest": "The guest",
  "mb.how_pay": "How?",
  "mb.method.business_invoice": "Business invoice",
  "mb.method.business_invoice_h": "The ride is added to the Business account billing under its terms.",
  "mb.method.card": "Credit card",
  "mb.method.card_h": "Instant card payment — secure SumUp form directly on this page.",
  "mb.method.card_guest": "Card on board",
  "mb.method.card_guest_h": "The guest pays by card via the chauffeur's SumUp terminal — no online payment.",
  "mb.method.payment_link": "Payment link",
  "mb.method.payment_link_h": "A SumUp payment link for the exact amount is emailed to the guest and can be copied here.",
  "mb.method.cash": "Cash",
  "mb.method.cash_h": "The guest will pay in cash; MILES records the collection.",
  "pay.pending": "Payment pending", "pay.paid": "Paid", "pay.copy": "Copy payment link",
  "pay.copied": "Link copied", "pay.cash_planned": "Cash payment expected",
  "pay.widget_title": "Mission payment",
  "pay.now_amount": "Pay {amount}",
  "pay.processing": "Processing…",
  "pay.paid_ok": "Payment confirmed — the mission is settled.",
  "pay.failed": "The payment was declined. Check the card or try again.", "pay.retry": "Retry payment",
  "pay.pending_check": "Verifying payment — the status will be confirmed in a moment.",
  "pay.widget_unavailable": "The payment form could not be created — regenerate it from the mission.",
  "pay.on_invoice": "On the Business invoice", "pay.now": "Pay online",
  "pay.link_sent": "The link was emailed to the guest with the confirmation. It updates automatically once paid.",
  "pay.success": "Payment received — the mission is marked as paid.",
  "pay.cancelled": "Payment interrupted — the mission remains pending payment.",
  "mb.bag_count": "Number of bags", "mb.bag_types": "Types (suitcases, skis…)",
  "mb.oversized": "Oversized luggage", "mb.collect_from": "Person handing over the bags",
  "mb.deliver_to": "Recipient", "mb.deliver_before": "Deliver before",
  "mb.item_description": "Item description", "mb.fragile": "Fragile",
  "mb.sender": "Sender", "mb.recipient": "Recipient",
  "mb.recurrence": "Recurrence", "mb.every": "Every", "mb.from": "From", "mb.to": "To",
  "mb.weekday.0": "Monday", "mb.weekday.1": "Tuesday", "mb.weekday.2": "Wednesday",
  "mb.weekday.3": "Thursday", "mb.weekday.4": "Friday", "mb.weekday.5": "Saturday", "mb.weekday.6": "Sunday",
  "mb.shuttle_frequency": "Frequency (minutes)", "mb.shuttle_window": "Time window",
  "mb.custom_desc": "Describe what you need",
  "mb.custom_hint": "Photo, document or instructions: email them to info@gomiles.ch quoting your mission number.",
  "mb.confirm": "Confirm this mission", "mb.creating": "We're arranging your ride…",
  "mb.price_est": "Estimated price", "mb.to_quote": "Price confirmed by MILES shortly",
  "mb.commission_est": "Estimated commission",
  "mb.confirmed_title": "Everything is ready.", "mb.confirmed_sub": "Mission confirmed — the guest has been notified.",
  "mb.track": "Track mission", "mb.add_return": "Book the return", "mb.new_one": "New mission",
  "mb.back": "Back", "mb.next": "Continue",
  "mb.select_type_first": "Pick a mission type first",
  "mb.flight_tracked": "MILES is tracking the flight. No action needed.",
  "mb.templates": "Saved missions", "mb.save_template": "Save as template",
  "mb.template_name": "Template name",

  "missions.title": "Missions", "missions.all": "All", "missions.empty": "No missions yet.",
  "missions.empty_hint": "Create your first mission — MILES handles the rest.",
  "missions.date": "Date", "missions.guest": "Guest", "missions.route": "Route",
  "missions.status": "Status", "missions.amount": "Amount",
  "status.confirmed": "Confirmed", "status.in_progress": "In progress", "status.completed": "Completed",
  "status.cancelled": "Cancelled", "status.to_quote": "To be quoted",
  "detail.timeline": "History", "detail.duplicate": "Duplicate", "detail.return": "Book the return",
  "detail.cancel": "Cancel mission", "detail.complete": "Mark completed",
  "detail.bookings": "Vehicles & tracking", "detail.custody": "Chain of custody",
  "detail.collected": "Collected", "detail.delivered": "Delivered", "detail.received_by": "Received by",
  "detail.photo": "Photo (URL)", "detail.update_custody": "Update",
  "detail.notes": "Notes", "detail.refs": "References", "detail.guests": "Guests",
  "detail.pricing": "Pricing", "detail.to_quote": "Price being quoted by MILES",
  "detail.tracking_link": "Tracking link",

  "guests.title": "Guests", "guests.subtitle": "Your frequent travellers — preferences, history, privacy.",
  "guests.new": "New guest", "guests.empty": "No guests yet.",
  "guests.first_name": "First name", "guests.last_name": "Last name", "guests.phone": "Phone",
  "guests.email": "Email", "guests.language": "Language", "guests.company": "Company",
  "guests.title_field": "Title / role", "guests.notes": "Notes", "guests.preferences": "Preferences",
  "guests.pref_hint": "E.g. communicate in English · prefers a Van · do not call before arrival",
  "guests.trips": "missions", "guests.recent": "Recent missions",
  "guests.book": "Book for this guest", "guests.edit": "Edit",
  "guests.anonymize": "Anonymize", "guests.anonymize_confirm": "Anonymize this profile? Personal data will be erased, financial history is kept.",
  "guests.delete": "Delete", "guests.save": "Save", "guests.cancel": "Cancel",


  "places.title": "Places", "places.subtitle": "Your frequent addresses — hotel, airports, stations, restaurants, FBO…",
  "places.new": "New place", "places.name": "Name", "places.address": "Address",
  "places.category": "Category", "places.empty": "No places yet.",
  "places.cat.hotel": "Hotel", "places.cat.airport": "Airport", "places.cat.station": "Station",
  "places.cat.restaurant": "Restaurant", "places.cat.company": "Company", "places.cat.clinic": "Clinic",
  "places.cat.fbo": "FBO", "places.cat.residence": "Residence", "places.cat.venue": "Venue",
  "places.cat.other": "Other",

  "billing.title": "Billing", "billing.balance": "Balance", "billing.open": "Open invoices",
  "billing.paid": "Paid invoices", "billing.spend_month": "Spend this month",
  "billing.unbilled": "Unbilled missions", "billing.next": "Next invoice",
  "billing.cycle": "Billing cycle", "billing.cycle.monthly": "Monthly",
  "billing.cycle.weekly": "Weekly", "billing.cycle.biweekly": "Biweekly",
  "billing.cycle.per_mission": "Per mission",

  "comm.title": "Commissions", "comm.available": "Available", "comm.pending": "Pending",
  "comm.paid_year": "Paid this year", "comm.lifetime": "Lifetime earnings",
  "comm.rate": "Current rate", "comm.date": "Date", "comm.booking": "Mission",
  "comm.guest": "Guest", "comm.service": "Service", "comm.commissionable": "Commissionable amount",
  "comm.commission": "Commission", "comm.status": "Status", "comm.payout": "Payout",
  "comm.export": "Export CSV", "comm.empty": "No commissions yet.",
  "comm.disabled": "Commissions are not enabled on your account — contact MILES.",
  "comm.st.pending": "Pending", "comm.st.confirmed": "Confirmed", "comm.st.available": "Available",
  "comm.st.paid": "Paid", "comm.st.cancelled": "Cancelled", "comm.st.adjusted": "Adjusted",
  "comm.payouts": "Payouts", "comm.payout_details": "Payout details",
  "comm.hold_warning": "Bank details recently changed — the next payout will be verified by MILES before execution.",

  "pay.holder": "Account holder", "pay.legal_name": "Legal company name", "pay.address": "Address",
  "pay.country": "Country", "pay.iban": "IBAN", "pay.bic": "BIC / SWIFT", "pay.currency": "Currency",
  "pay.accounting_email": "Accounting email", "pay.uid": "UID", "pay.vat": "VAT number",
  "pay.save": "Save", "pay.saved": "Details saved — MILES verification before next payout.",
  "pay.iban_invalid": "The IBAN entered is not valid.",

  "reports.title": "Reports", "reports.missions": "Missions", "reports.completed": "Completed",
  "reports.cancelled": "Cancelled", "reports.spend": "Spend", "reports.avg": "Average booking value",
  "reports.airport": "Airport transfers", "reports.hours": "Hours booked",
  "reports.guests": "Guests transported", "reports.luggage": "Luggage missions",
  "reports.commission": "Commission earned", "reports.by_type": "By mission type",


  "team.role.owner": "Owner", "team.role.admin": "Admin", "team.role.concierge": "Concierge",
  "team.role.front_desk": "Front Desk", "team.role.event_manager": "Event Manager",
  "team.role.finance": "Finance", "team.role.viewer": "Viewer", "team.role.booker": "Concierge",

  "settings.profile": "Partner profile", "settings.business_type": "Organisation type",
  "settings.bt.company": "Company", "settings.bt.hotel": "Hotel", "settings.bt.hotel_group": "Hotel group",
  "settings.bt.concierge": "Concierge", "settings.bt.travel_agency": "Travel agency",
  "settings.bt.event_agency": "Event agency", "settings.bt.clinic": "Clinic",
  "settings.bt.family_office": "Family office", "settings.bt.other": "Other",
  "settings.locations": "Properties", "settings.location_new": "Add a property",
  "settings.payout": "Payouts & bank details",
  "settings.activity": "Activity log",

  "palette.title": "Search & quick actions", "palette.new_mission": "New mission",
  "palette.open_today": "Open today", "palette.find_invoice": "Find an invoice",
  "palette.guests": "Guests", "palette.missions": "Missions", "palette.invoices": "Invoices",
  "palette.empty": "No results.",
  "common.close": "Close", "common.loading": "Loading…", "common.save": "Save",
  "common.delete": "Delete", "common.edit": "Edit", "common.view": "View",
  "common.error": "Something went wrong.",
};

const de = {
  "comm.rate_applied": "Angewandter Satz", "comm.no_payouts": "Noch keine Auszahlungen.", "comm.bank_restricted": "Nur für Owner / Admin — kontaktieren Sie Ihren Administrator.",
  "mb.mode.flight": "Flug", "mb.mode.train": "Zug", "team.saved": "Mitglied gespeichert", "common.invalid": "Einige Felder sind unvollständig — bitte prüfen.",
  "nav.overview": "Übersicht", "nav.new_mission": "Neuer Auftrag", "nav.missions": "Aufträge",
  "nav.guests": "Gäste",
  "nav.places": "Orte", "nav.billing": "Abrechnung", "nav.commissions": "Provisionen",
  "nav.reports": "Berichte", "nav.team": "Team", "nav.settings": "Einstellungen",
  "hub.new": "+ Auftrag", "hub.search_placeholder": "Gast, Auftrag, Flug oder Rechnung suchen…",
  "hub.hello": "Hallo {name}", "hub.logout": "Abmelden", "hub.back_site": "← Zur Website",

  "overview.welcome": "Ihr Tag auf einen Blick.", "overview.today": "Heute",
  "overview.arrivals": "Ankünfte", "overview.departures": "Abfahrten", "overview.active": "Aktive Aufträge",
  "overview.completed": "Abgeschlossen", "overview.action_required": "Handlung erforderlich",
  "overview.none": "Alles unter Kontrolle — MILES überwacht alles für Sie.",
  "overview.timeline": "Operative Timeline", "overview.upcoming": "Demnächst",
  "overview.quick": "Schnellbuchung", "overview.quick_hint": "Für einfache Anliegen — der Mission Builder übernimmt bei Bedarf.",
  "overview.pickup": "Abholung", "overview.destination": "Ziel", "overview.when": "Wann?",
  "overview.guest": "Gast", "overview.continue": "Weiter",
  "overview.spend_month": "Ausgaben diesen Monat", "overview.missions_month": "Aufträge diesen Monat",
  "overview.no_missions": "Heute keine Aufträge — ein ruhiger Tag.",

  "hub.title": "Was sollen wir organisieren?", "hub.subtitle": "Beschreiben Sie den Bedarf — MILES erledigt den Rest.",
  "type.transfer": "Privattransfer", "type.transfer_d": "Eine private Fahrt mit beliebig vielen Zwischenstopps.",
  "type.airport": "Flughafen-Transfer", "type.airport_d": "Abholung im Zusammenhang mit Flug oder Zug.",
  "type.private_aviation": "Privatflug", "type.private_aviation_d": "Tail Number, FBO, Handler — ohne falsche Linienflugnummer.",
  "type.hourly": "Fahrer zur Verfügung", "type.hourly_d": "Ein paar Stunden, ein halber oder ganzer Tag.",
  "type.multi_stop": "Mehrere Stopps", "type.multi_stop_d": "Eine Route mit mehreren Zielen.",
  "type.group": "Gruppe", "type.group_d": "Mehrere Gäste, eventuell mehrere Fahrzeuge.",
  "type.event": "Event", "type.event_d": "Konferenz, Hochzeit, Delegation, Seminar…",
  "type.shuttle": "Shuttle", "type.shuttle_d": "Rotationen zwischen mehreren Orten.",
  "type.luggage": "Gepäck", "type.luggage_d": "Gepäcktransport mit oder ohne Gast.",
  "type.delivery": "Lieferung", "type.delivery_d": "Dokument, Gegenstand oder persönliche Effekten.",
  "type.recurring": "Wiederkehrender Auftrag", "type.recurring_d": "Eine wiederholte Fahrt, z. B. jeden Montag 07:30.",
  "type.custom": "Besondere Anfrage", "type.custom_d": "Für alles andere — MILES kümmert sich darum.",

  "mb.who": "Wen oder was bewegen wir?", "mb.where": "Wohin?", "mb.when": "Wann?",
  "mb.how": "Wie?", "mb.instructions": "Anweisungen", "mb.payment": "Wer zahlt?",
  "mb.review": "Auftragsübersicht",
  "mb.guests": "Gäste", "mb.add_guest": "Gast hinzufügen", "mb.new_guest": "Neuer Gast",
  "mb.search_guest": "Im Verzeichnis suchen…", "mb.save_guest": "Als Gast speichern",
  "mb.passengers": "Passagiere", "mb.luggage": "Gepäck",
  "mb.pickup": "Abholung", "mb.dropoff": "Ziel", "mb.add_stop": "Stopp hinzufügen",
  "mb.stop": "Stopp", "mb.date": "Datum", "mb.time": "Uhrzeit", "mb.now": "So bald wie möglich",
  "mb.flight_number": "Flugnummer", "mb.terminal": "Terminal", "mb.train_number": "Zug (optional)",
  "mb.station": "Bahnhof", "mb.platform": "Gleis",
  "mb.tail_number": "Tail Number", "mb.fbo": "FBO", "mb.handler": "Handler", "mb.eta": "ETA",
  "mb.aviation_contact": "Aviation-Kontakt",
  "mb.duration": "Dauer", "mb.hours": "Stunden", "mb.schedule": "Geplantes Programm",
  "mb.schedule_hint": "Oder einfach: Route mit dem Fahrer abstimmen.",
  "mb.flexible_dest": "Flexibles Ziel",
  "mb.vehicle": "Fahrzeug", "mb.vehicles": "Fahrzeuge",
  "mb.vehicle.standard": "Standard", "mb.vehicle.business": "Business", "mb.vehicle.first": "First", "mb.vehicle.van": "Van",
  "mb.vehicle.luggage_van": "Gepäck-Van", "mb.count": "Anzahl",
  "mb.driver_language": "Sprache des Fahrers", "mb.internal_note": "Interne Notiz",
  "mb.driver_note": "Anweisung an den Fahrer",
  "mb.payer.partner": "Der Partner",
  "mb.payer.guest": "Der Gast",
  "mb.how_pay": "Wie?",
  "mb.method.business_invoice": "Business-Rechnung",
  "mb.method.business_invoice_h": "Die Fahrt wird der Business-Abrechnung des Kontos zu dessen Konditionen hinzugefügt.",
  "mb.method.card": "Bankkarte",
  "mb.method.card_h": "Sofortige Kartenzahlung — sicheres SumUp-Formular direkt auf dieser Seite.",
  "mb.method.card_guest": "Karte an Bord",
  "mb.method.card_guest_h": "Der Gast zahlt per Karte über das SumUp-Terminal des Chauffeurs — keine Online-Zahlung.",
  "mb.method.payment_link": "Zahlungslink",
  "mb.method.payment_link_h": "Ein SumUp-Zahlungslink über den exakten Betrag wird dem Gast gemailt und kann hier kopiert werden.",
  "mb.method.cash": "Bargeld",
  "mb.method.cash_h": "Der Gast zahlt bar; MILES erfasst den Zahlungseingang.",
  "pay.pending": "Zahlung ausstehend", "pay.paid": "Bezahlt", "pay.copy": "Zahlungslink kopieren",
  "pay.copied": "Link kopiert", "pay.cash_planned": "Barzahlung vorgesehen",
  "pay.widget_title": "Zahlung der Mission",
  "pay.now_amount": "{amount} bezahlen",
  "pay.processing": "Zahlung läuft…",
  "pay.paid_ok": "Zahlung bestätigt — die Mission ist beglichen.",
  "pay.failed": "Die Zahlung wurde abgelehnt. Prüfen Sie die Karte oder versuchen Sie es erneut.", "pay.retry": "Zahlung erneut versuchen",
  "pay.pending_check": "Zahlung wird geprüft — der Status wird gleich bestätigt.",
  "pay.widget_unavailable": "Das Zahlungsformular konnte nicht erstellt werden — generieren Sie es in der Mission neu.",
  "pay.on_invoice": "Auf der Business-Rechnung", "pay.now": "Online bezahlen",
  "pay.link_sent": "Der Link wurde dem Gast mit der Bestätigung gemailt. Er aktualisiert sich nach Zahlung automatisch.",
  "pay.success": "Zahlung erhalten — der Auftrag ist als bezahlt markiert.",
  "pay.cancelled": "Zahlung abgebrochen — der Auftrag bleibt zahlungsoffen.",
  "mb.bag_count": "Anzahl Gepäckstücke", "mb.bag_types": "Arten (Koffer, Skier…)",
  "mb.oversized": "Übergrosses Gepäck", "mb.collect_from": "Person bei der Abholung",
  "mb.deliver_to": "Empfänger", "mb.deliver_before": "Zu liefern vor",
  "mb.item_description": "Beschreibung des Gegenstands", "mb.fragile": "Zerbrechlich",
  "mb.sender": "Absender", "mb.recipient": "Empfänger",
  "mb.recurrence": "Wiederholung", "mb.every": "Jeden", "mb.from": "Vom", "mb.to": "Bis",
  "mb.weekday.0": "Montag", "mb.weekday.1": "Dienstag", "mb.weekday.2": "Mittwoch",
  "mb.weekday.3": "Donnerstag", "mb.weekday.4": "Freitag", "mb.weekday.5": "Samstag", "mb.weekday.6": "Sonntag",
  "mb.shuttle_frequency": "Frequenz (Minuten)", "mb.shuttle_window": "Zeitfenster",
  "mb.custom_desc": "Beschreiben Sie, was Sie brauchen",
  "mb.custom_hint": "Foto, Dokument oder Anweisungen: senden Sie sie an info@gomiles.ch mit Ihrer Auftragsnummer.",
  "mb.confirm": "Auftrag bestätigen", "mb.creating": "Wir organisieren Ihre Fahrt…",
  "mb.price_est": "Geschätzter Preis", "mb.to_quote": "Preis folgt in Kürze durch MILES",
  "mb.commission_est": "Geschätzte Provision",
  "mb.confirmed_title": "Alles bereit.", "mb.confirmed_sub": "Auftrag bestätigt — der Gast wurde benachrichtigt.",
  "mb.track": "Auftrag verfolgen", "mb.add_return": "Rückfahrt buchen", "mb.new_one": "Neuer Auftrag",
  "mb.back": "Zurück", "mb.next": "Weiter",
  "mb.select_type_first": "Wählen Sie zuerst einen Auftragstyp",
  "mb.flight_tracked": "MILES verfolgt den Flug. Keine Aktion nötig.",
  "mb.templates": "Gespeicherte Aufträge", "mb.save_template": "Als Vorlage speichern",
  "mb.template_name": "Name der Vorlage",

  "missions.title": "Aufträge", "missions.all": "Alle", "missions.empty": "Noch keine Aufträge.",
  "missions.empty_hint": "Erstellen Sie Ihren ersten Auftrag — MILES erledigt den Rest.",
  "missions.date": "Datum", "missions.guest": "Gast", "missions.route": "Strecke",
  "missions.status": "Status", "missions.amount": "Betrag",
  "status.confirmed": "Bestätigt", "status.in_progress": "Unterwegs", "status.completed": "Abgeschlossen",
  "status.cancelled": "Storniert", "status.to_quote": "Wird offeriert",
  "detail.timeline": "Verlauf", "detail.duplicate": "Duplizieren", "detail.return": "Rückfahrt buchen",
  "detail.cancel": "Auftrag stornieren", "detail.complete": "Als abgeschlossen markieren",
  "detail.bookings": "Fahrzeuge & Tracking", "detail.custody": "Gepäck-Verfolgung",
  "detail.collected": "Abgeholt", "detail.delivered": "Geliefert", "detail.received_by": "Empfangen von",
  "detail.photo": "Foto (URL)", "detail.update_custody": "Aktualisieren",
  "detail.notes": "Notizen", "detail.refs": "Referenzen", "detail.guests": "Gäste",
  "detail.pricing": "Preis", "detail.to_quote": "Preis wird durch MILES offeriert",
  "detail.tracking_link": "Tracking-Link",

  "guests.title": "Gäste", "guests.subtitle": "Ihre Stammgäste — Präferenzen, Historie, Datenschutz.",
  "guests.new": "Neuer Gast", "guests.empty": "Noch keine Gäste.",
  "guests.first_name": "Vorname", "guests.last_name": "Nachname", "guests.phone": "Telefon",
  "guests.email": "E-Mail", "guests.language": "Sprache", "guests.company": "Firma",
  "guests.title_field": "Titel / Funktion", "guests.notes": "Notizen", "guests.preferences": "Präferenzen",
  "guests.pref_hint": "Z. B. Kommunikation auf Englisch · bevorzugt Van · nicht vor Ankunft anrufen",
  "guests.trips": "Aufträge", "guests.recent": "Letzte Aufträge",
  "guests.book": "Für diesen Gast buchen", "guests.edit": "Bearbeiten",
  "guests.anonymize": "Anonymisieren", "guests.anonymize_confirm": "Dieses Profil anonymisieren? Persönliche Daten werden gelöscht, die Finanzhistorie bleibt erhalten.",
  "guests.delete": "Löschen", "guests.save": "Speichern", "guests.cancel": "Abbrechen",


  "places.title": "Orte", "places.subtitle": "Ihre häufigen Adressen — Hotel, Flughäfen, Bahnhöfe, Restaurants, FBO…",
  "places.new": "Neuer Ort", "places.name": "Name", "places.address": "Adresse",
  "places.category": "Kategorie", "places.empty": "Noch keine Orte.",
  "places.cat.hotel": "Hotel", "places.cat.airport": "Flughafen", "places.cat.station": "Bahnhof",
  "places.cat.restaurant": "Restaurant", "places.cat.company": "Firma", "places.cat.clinic": "Klinik",
  "places.cat.fbo": "FBO", "places.cat.residence": "Residenz", "places.cat.venue": "Venue",
  "places.cat.other": "Andere",

  "billing.title": "Abrechnung", "billing.balance": "Saldo", "billing.open": "Offene Rechnungen",
  "billing.paid": "Bezahlte Rechnungen", "billing.spend_month": "Ausgaben diesen Monat",
  "billing.unbilled": "Nicht verrechnete Aufträge", "billing.next": "Nächste Rechnung",
  "billing.cycle": "Abrechnungszyklus", "billing.cycle.monthly": "Monatlich",
  "billing.cycle.weekly": "Wöchentlich", "billing.cycle.biweekly": "Zweiwöchentlich",
  "billing.cycle.per_mission": "Pro Auftrag",

  "comm.title": "Provisionen", "comm.available": "Verfügbar", "comm.pending": "Ausstehend",
  "comm.paid_year": "Dieses Jahr ausbezahlt", "comm.lifetime": "Gesamt kumuliert",
  "comm.rate": "Aktueller Satz", "comm.date": "Datum", "comm.booking": "Auftrag",
  "comm.guest": "Gast", "comm.service": "Service", "comm.commissionable": "Provisionsbasis",
  "comm.commission": "Provision", "comm.status": "Status", "comm.payout": "Auszahlung",
  "comm.export": "CSV exportieren", "comm.empty": "Noch keine Provisionen.",
  "comm.disabled": "Provisionen sind auf Ihrem Konto nicht aktiviert — kontaktieren Sie MILES.",
  "comm.st.pending": "Ausstehend", "comm.st.confirmed": "Bestätigt", "comm.st.available": "Verfügbar",
  "comm.st.paid": "Ausbezahlt", "comm.st.cancelled": "Storniert", "comm.st.adjusted": "Angepasst",
  "comm.payouts": "Auszahlungen", "comm.payout_details": "Bankdaten",
  "comm.hold_warning": "Bankdaten kürzlich geändert — die nächste Auszahlung wird von MILES vor Ausführung geprüft.",

  "pay.holder": "Kontoinhaber", "pay.legal_name": "Firmenname", "pay.address": "Adresse",
  "pay.country": "Land", "pay.iban": "IBAN", "pay.bic": "BIC / SWIFT", "pay.currency": "Währung",
  "pay.accounting_email": "Buchhaltungs-E-Mail", "pay.uid": "UID", "pay.vat": "MWST-Nr.",
  "pay.save": "Speichern", "pay.saved": "Daten gespeichert — MILES prüft vor der nächsten Auszahlung.",
  "pay.iban_invalid": "Die eingegebene IBAN ist ungültig.",

  "reports.title": "Berichte", "reports.missions": "Aufträge", "reports.completed": "Abgeschlossen",
  "reports.cancelled": "Storniert", "reports.spend": "Ausgaben", "reports.avg": "Ø Auftragswert",
  "reports.airport": "Flughafentransfers", "reports.hours": "Gebuchte Stunden",
  "reports.guests": "Beförderte Gäste", "reports.luggage": "Gepäckaufträge",
  "reports.commission": "Verdiente Provisionen", "reports.by_type": "Nach Auftragstyp",


  "team.role.owner": "Owner", "team.role.admin": "Admin", "team.role.concierge": "Concierge",
  "team.role.front_desk": "Front Desk", "team.role.event_manager": "Event Manager",
  "team.role.finance": "Finance", "team.role.viewer": "Viewer", "team.role.booker": "Concierge",

  "settings.profile": "Partnerprofil", "settings.business_type": "Organisationstyp",
  "settings.bt.company": "Unternehmen", "settings.bt.hotel": "Hotel", "settings.bt.hotel_group": "Hotelgruppe",
  "settings.bt.concierge": "Concierge", "settings.bt.travel_agency": "Reisebüro",
  "settings.bt.event_agency": "Eventagentur", "settings.bt.clinic": "Klinik",
  "settings.bt.family_office": "Family Office", "settings.bt.other": "Andere",
  "settings.locations": "Häuser", "settings.location_new": "Haus hinzufügen",
  "settings.payout": "Auszahlungen & Bankdaten",
  "settings.activity": "Aktivitätsprotokoll",

  "palette.title": "Suche & Schnellaktionen", "palette.new_mission": "Neuer Auftrag",
  "palette.open_today": "Heute öffnen", "palette.find_invoice": "Rechnung suchen",
  "palette.guests": "Gäste", "palette.missions": "Aufträge", "palette.invoices": "Rechnungen",
  "palette.empty": "Keine Ergebnisse.",
  "common.close": "Schliessen", "common.loading": "Laden…", "common.save": "Speichern",
  "common.delete": "Löschen", "common.edit": "Bearbeiten", "common.view": "Ansehen",
  "common.error": "Ein Fehler ist aufgetreten.",
};

const DICTS = { fr, en, de };

export function useBiz() {
  const { lang } = useLang();
  const dict = DICTS[lang] || DICTS.fr;
  const t = (key) => dict[key] ?? DICTS.fr[key] ?? key;
  return { t, lang };
}
